import { EMR_APIS } from "@/api_framework/api_config";

import { IEMRSingleEMRDetailsResponse } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
interface IAPIreturnProps {
  status: boolean;
  data: any;
}

AxiosCurlirize(axios, () => {});

export const usePetBodyandDentalScoreAPI = () => {
  const [petHelthDetails, setPetHelthDetails] = useState<any>(null);

  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response: IAPIreturnProps = await axios
        .get(`${EMR_APIS?.PET_BODY_DENTAL_SCORE?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IEMRSingleEMRDetailsResponse>) => {
          if (res.data.status === true && res.data) {
            setPetHelthDetails(res.data.data);
            return { status: true, data: res.data.data };
          } else {
            setPetHelthDetails(null);
            return { status: false, data: null };
          }
        })
        .catch((e: AxiosError) => {
          captureError(e);
          sendCurl(e.config["curlCommand"]);
          setPetHelthDetails(null);
          return { status: false, data: null };
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return { execute, petHelthDetails };
};
